<mat-form-field *transloco="let translate" appRemoveAriaOwns>
    <mat-label *transloco="let translate">{{ translate('Select City') }}</mat-label>
    <mat-select [formControl]="control" [id]="id || 'city'" [errorStateMatcher]="matcher" disableOptionCentering>
        <mat-option>
            <em [textContent]="'--' + translate('Please select') + '--'"></em>
        </mat-option>
        <div class="selectSearchFilter">
            <mat-form-field>
                <mat-label *transloco="let translate">{{ translate('Search') }}</mat-label>
                <input matInput class="inputSearchField" autocomplete="off" [(ngModel)]="city" />
                <material-button
                                 matSuffix
                                 [classList]="['selectCloseIcon']"
                                 *ngIf="city"
                                 buttonType="icon"
                                 size="small"
                                 [titleText]="'Clear'"
                                 prefixIconType="material"
                                 prefixIcon="close"
                                 (buttonClicked)='$event.stopPropagation();city ="";'>
                </material-button>
            </mat-form-field>
        </div>
        <mat-option *ngFor="let option of cities | multiFilter : city" [value]="option.id.toString()">
            <span [textContent]="option.name"></span>
        </mat-option>
    </mat-select>
    <mat-hint align="start" *ngIf="required && !(errors && errors.length > 0)">
        <strong>
            <span>* </span><span [textContent]="translate('required')"></span></strong>
    </mat-hint>
    <mat-error *ngIf="control.hasError('errors')" [title]="errors">
        <span [textContent]="errors"></span>
    </mat-error>
</mat-form-field>
